import OSS from 'ali-oss'
import md5 from 'js-md5'; // 上传文件需要将文件名
import myStorage from '@/service/storage';
import { PostData } from '../../api/fetchdata.js';

function isExpired(dateString) { // 判断osstoken是否过期
  var givenDate = new Date(dateString);
  var currentDate = new Date();
  if (givenDate.getTime() < currentDate.getTime()) {
    return true; // 给定时间已过期
  } else {
    return false; // 给定时间未过期
  }
}

function getStsToken(microservices) {
	return new Promise((resolve, reject) => {
		let ossConfig = myStorage.getItem(`${microservices}_ossConfig`);
		console.log()
		if (ossConfig) {
			if(isExpired(ossConfig.data.expiration)){
				PostData({ microservices })
				.then((res) => {
					let ossExpiration = Date.now() + 600000; // 10 minutes from now
					myStorage.setItem(`${microservices}_ossExpiration`, ossExpiration);
					myStorage.setItem(`${microservices}_ossConfig`, res.data);
					resolve({ data: res.data, ret: res.ret });
				})
				.catch((error) => {
						reject(error);
				});
			} else {
				resolve({ data: ossConfig, ret: 200 });
			}
			
		} else {
			PostData({ microservices })
			.then((res) => {
				let ossExpiration = Date.now() + 600000; // 10 minutes from now
				myStorage.setItem(`${microservices}_ossExpiration`, ossExpiration);
				myStorage.setItem(`${microservices}_ossConfig`, res.data);
				resolve({ data: res.data, ret: res.ret });
			})
			.catch((error) => {
					reject(error);
			});
		}
	});
}
// 从后端获取ststoken 并初始化ossclient，通过promise返回ossclient和stsToken
export async function initOssClient(microservices = 'api//oss/accredit/tj') {
	try {
		const { data } = await getStsToken(microservices);
		if (data.ret == 200) {
			const client = new OSS({
				accessKeyId: data.data.access_key_id,
				accessKeySecret: data.data.access_key_secret,
				stsToken: data.data.security_token,
				endpoint: data.data.endpoint,
				bucket: data.data.bucket,
			});
			return { client };
		}
	} catch (error) {
		console.error("Error initializing OSS client:", error);
		throw error; // Propagate the error further if needed
	}
}

/**
 * base格式图片传oss
 * @param {Object} client
 * @param {Object} file
 * @param {Object} dir
 */
 export async function uploadBase(client, file, dir) {
	let fileName = 'uploadBaseName';
	let timeStr = new Date().getTime();
	fileName+=timeStr;
	const {
		url
	} = await client.put(dir + md5(fileName) + '.jpg', file)
	return url
};

/**
 * 普通上传,普通上传不支持实时进度
 * @param {Object} client
 * @param {Object} file
 * @param {Object} dir
 */
export async function upload(client, file, dir) {
	let fileName = file.name.slice(0, file.name.lastIndexOf('.'));
	let timeStr = new Date().getTime();
	fileName+=timeStr;
	let fileType = file.name.slice(Number(file.name.lastIndexOf('.')), file.name.length);
	const {
		url
	} = await client.put(dir + md5(fileName) + fileType, file)
	return url
};
/**
 * 断点续传
 * @param {Object} client oss客户端
 * @param {Object} file 上传的文件
 * @param {Object} dir  oss上传的文件夹
 * @param {Object} progressCallback 分片回调进度
 * @param {Object} checkPoint  断点
 */
export async function multipartUpload(client, file, dir, progressCallback, checkPoint) {
	let fileName = file.name.slice(0, file.name.lastIndexOf('.'));
	let timeStr = new Date().getTime();
	fileName+=timeStr;
	let fileType = file.name.slice(Number(file.name.lastIndexOf('.')), file.name.length);
	try {
		let options = {
			// 获取分片上传进度、断点和返回值。
			progress: progressCallback,
			// 断点
			checkpoint: checkPoint,
		}
		const {
			res: resp
		} = await client.multipartUpload(dir + (md5(fileName) + fileType), file, options)
		return resp.requestUrls
	} catch (e) {
		console.log(e);
	}
};
/**
 * 分片上传
 * @param {Object} client oss客户端
 * @param {Object} file 上传的文件
 * @param {Object} dir 上传oss的文件夹
 * @param {Object} progressCallback 分片进度回调
 */
export async function partUpload(client, file, dir, progressCallback, checkPoint) {
	let fileName = file.name.slice(0, file.name.lastIndexOf('.'));
	let timeStr = new Date().getTime();
	fileName+=timeStr;
	let fileType = file.name.slice(Number(file.name.lastIndexOf('.')), file.name.length);
	try {
		let options = {
			// 获取分片上传进度、断点和返回值。
			progress: progressCallback,
			// 设置并发上传的分片数量。
			parallel: 8,
			// 设置分片大小。默认值为1 MB，最小值为100 KB。
			partSize: 100 * 1024,
			mime: file.type,
			// 断点
			checkpoint: checkPoint,
		}
		const {
			res: resp
		} = await client.multipartUpload(dir + (md5(fileName) + fileType), file, options)
		return resp.requestUrls
	} catch (e) {
		console.log(e);
	}
}
/**
 * 结束上传并删除碎片
 * @param {Object} client
 * @param {Object} uploadId
 * @param {Object} name
 */
export function abortUpload(client, uploadId, name) {
	client.abortMultipartUpload(name, uploadId)
}



// WEBPACK FOOTER //
// ./src/components/UploadPanel/aliOssUpload.js